import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class RoleGuard implements CanActivate {
    private myIdUrl = process.env.API_SFOATHURL;

    constructor(private authService: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let url: string = state.url;
        return  this.authService.subscribeToLoginService()
        .map((userInfo) => {
            
            if(userInfo != null && userInfo.userId != null)
                {
                    //let roles = [process.env.CLEARANCE_ROLE,process.env.PRODUCTION_ROLE];
                    let roles = route.data["roles"] as Array<string>;
                    if(roles == null || (userInfo != null && roles.some(r => userInfo.role.indexOf(r) >= 0)))
                    {
                        return true;
                    }
                    this.router.navigate(['/401']);
                    return false;
                }else{
                    
                    if(!window.location.href.includes('token')){
                        console.log(this.myIdUrl);
                        
                        window.location.href = this.myIdUrl;
                        if(window.location.href.includes('/#/'))
                        {
                            var url = window.location.href.slice(window.location.href.indexOf('#')+1);
                            localStorage.setItem('redirectUrl', url);
                        }
                        return false;    
                    }else{
                        this.router.navigate(['/401']);
                        return false;
                    }
                }
                

            },
            err => {
                console.log('error: ' + err)
                return false;
            });
                
    }

   
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/role-guard.service.ts